module.exports = __webpack_public_path__ + "assets/images/df467bbbe6f2444e462c328a19050795.png";